import { AppApi } from './app.api';
import { AppServices } from './app.services';

export const APP_APIS = [AppApi, AppServices];
